import { Message } from 'element-ui'

// 合法空列表必须是 []；结构错误应提示失败，不能静默伪装成查询成功。
export function listRows(data, allowWrapper = true) {
  const rows = Array.isArray(data) ? data : allowWrapper && data && (data.list !== undefined ? data.list : data.items)
  if (!Array.isArray(rows) || rows.some(row => !row || typeof row !== 'object' || Array.isArray(row))) {
    const error = new Error('AI训战列表数据格式异常，请刷新重试')
    Message({ message: error.message, type: 'error' })
    throw error
  }
  return rows
}

export function treeRows(data, allowWrapper = true) {
  const rows = listRows(data, allowWrapper)
  rows.forEach(row => {
    // 仅根响应允许 list/items 包装；控件递归使用的 children 必须保持数组。
    if (row.children !== undefined && row.children !== null) treeRows(row.children, false)
  })
  return rows
}

export function pageParams(query = {}) {
  const { pageNo, ...params } = query
  return { ...params, page: pageNo === undefined ? (params.page || 1) : pageNo }
}

export function recordParams(query = {}) {
  const { startDate, endDate, passed, ...params } = pageParams(query)
  // 日末使用排他的次日边界，覆盖数据库支持的小数秒；列表与导出共用。
  if (startDate) params.startDate = startDate
  if (endDate) params.endDate = endDate
  if (passed === true || passed === false) params.passed = passed
  return params
}
